
import { defineComponent, computed } from "vue-demi";

export default defineComponent({
  name: "NewConfirmPopup",

  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    message: String,
    title: String,
    cancelLabel: { type: String, default: "No" },
    okLabel: { type: String, default: "Yes" },
    okDisabled: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
  },

  emits: ["update:modelValue", "cancel", "ok", "update:isOpen"],

  setup(props, { emit, slots }) {
    const hasSlotContent = computed(() => {
      if (!slots.content) return false;

      return slots.content().length > 0;
    });

    const isOpen = computed({
      get: () => props.modelValue,
      set: (value) => emit("update:modelValue", value),
    });

    const close = () => {
      isOpen.value = false;
    };

    function onCancel() {
      emit("cancel");

      isOpen.value = false;
    }

    function onOk() {
      emit("ok");

      isOpen.value = false;
    }

    return { hasSlotContent, isOpen, close, onCancel, onOk };
  },
});
